import axios from '../../axiosConfig'
import { tokenConfig } from '../auth'
import {
  FETCH_EX_SERIES_PERFILES,
  FETCH_MAS_SERIES,
  GET_EX_SERIES_PERFILES,
  GET_MAS_SERIES,
  SET_BUSQUEDA_SERIE,
  SET_EX_SERIE_SELECCIONADA,
  UNSET_EX_SERIE_SELECCIONADA,
} from '../types'

// GET EX SERIES PERFILES
export const getExSeries =
  (grupo_perfil = '', search = '', paginar = 'N') =>
  (dispatch, getState) => {
    dispatch({
      type: FETCH_EX_SERIES_PERFILES,
    })

    let config = tokenConfig(getState)

    if (grupo_perfil == null || grupo_perfil == 'null') grupo_perfil = ''

    axios
      .get(`/exSeries/?grupo_perfil=${grupo_perfil}&search=${search}&paginar=${paginar}`, config)
      .then(res => {
        dispatch({
          type: GET_EX_SERIES_PERFILES,
          payload: res.data,
        })
      })
      .catch(err => {
        console.log(err)
      })
  }

// GET MÁS SERIES
export const getMasSeries =
  (url, grupo_perfil, limit = 15) =>
  (dispatch, getState) => {
    dispatch({
      type: FETCH_MAS_SERIES,
    })

    if (grupo_perfil == null || grupo_perfil === '') grupo_perfil = ''
    if (url == null || url === '') {
      url = `/exSeries/?grupo_perfil=${grupo_perfil}&search=&paginar=S&limit=${limit}`
    } else {
      if (url.startsWith('http://')) {
        url = url.replace('http://', 'https://')
      }
    }

    axios
      .get(url, tokenConfig(getState))
      .then(res => {
        dispatch({
          type: GET_MAS_SERIES,
          payload: res.data,
        })
      })
      .catch(err => console.log(err))
  }

export const setBusquedaSerie = search => (dispatch, getState) => {
  dispatch({
    type: SET_BUSQUEDA_SERIE,
    payload: search,
  })
}

export const setExSerieSeleccionada = codigo => (dispatch, getState) => {
  dispatch({
    type: SET_EX_SERIE_SELECCIONADA,
    payload: codigo,
  })
}

export const unsetExSerieSeleccionada = () => (dispatch, getState) => {
  dispatch({
    type: UNSET_EX_SERIE_SELECCIONADA,
  })
}
